export const DoctorCompany = () => {
  return <h1>Doctor company</h1>;
};
